import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AffiliateLogin from "./login";
import AffiliateSignup from "./signup";
import AffiliateForgotPassword from "./forgot-password";
import AffiliateDashboard from "./dashboard";
import AffiliateLanding from "./landing";
import AffiliateCampaigns from "./campaigns";
import AffiliateCustomers from "./customers";
import AffiliateCommissions from "./commissions";
import AffiliatePayouts from "./payouts";
import AffiliateSettings from "./settings";
import MarketingKit from "./marketingKit";

// Simple Auth Check for Affiliate is now handled in AffiliateLayout,
// but we still need a way to group protected routes.

const ProtectedRoutes = () => {
  return (
    <Switch>
      <Route path="/dashboard" component={AffiliateDashboard} />
      <Route path="/campaigns" component={AffiliateCampaigns} />
      <Route path="/customers" component={AffiliateCustomers} />
      <Route path="/commissions" component={AffiliateCommissions} />
      <Route path="/payouts" component={AffiliatePayouts} />
      <Route path="/marketing-kit" component={MarketingKit} />
      <Route path="/settings" component={AffiliateSettings} />
      <Redirect to="/dashboard" />
    </Switch>
  );
};

const AffiliateApp = () => {
  return (
    <Switch>
      {/* Public Routes */}
      <Route exact path="/" component={AffiliateLanding} />
      <Route path="/login" component={AffiliateLogin} />
      <Route path="/signup" component={AffiliateSignup} />
      <Route path="/forgot-password" component={AffiliateForgotPassword} />
      <Route path="/reset-password" component={AffiliateForgotPassword} />

      {/* Protected Routes Wrapper */}
      <Route render={(props) => <ProtectedRoutes {...props} />} />
    </Switch>
  );
};

export default AffiliateApp;
